import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';
import { Doughnut } from 'react-chartjs-2';

import Typography from '@material-ui/core/Typography';

import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import RoomIcon from '@material-ui/icons/Room';

import Paper from '~/components/Paper';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import CardMini from '~/components/Card/CardMini';
import LinearProgress from '~/components/LinearProgress';

import formatNumber from '~/utils/Number/formatNumber';
import Request from '~/providers/Request';

import colors from '~/utils/colors';

function ShowCorporation() {
  const { t } = useTranslation();

  const [doctorCount, setDoctorCount] = useState(null);
  const [doctorAllCount, setDoctorAllCount] = useState(null);
  const [drivingCount, setDrivingCount] = useState(null);
  const [emergencyCount, setEmergencyCount] = useState(null);
  const [usersCount, setUsersCount] = useState(null);
  const [packagesBySpecialty, setPackagesByspecialty] = useState(null);

  const [loading, setLoading] = useState(false);

  const getPiePackagesBySpecialty = () => {
    const labels = [];
    const data = [];
    const pieColors = [];

    if (packagesBySpecialty) {
      packagesBySpecialty.forEach((element, index) => {
        labels.push(`${dig(element, 'specialty', 'name')}: ${element.count}`);
        data.push(element.count);
        pieColors.push(colors[index]);
      });
    }

    return {
      labels: labels,
      datasets: [
        {
          backgroundColor: pieColors,
          hoverBackgroundColor: pieColors,
          data: data,
        },
      ],
    };
  };

  const pieOptions = {
    tooltips: {
      backgroundColor: 'rgb(255,255,255)',
      bodyFontColor: '#858796',
      borderColor: '#dddfeb',
      borderWidth: 1,
      xPadding: 15,
      yPadding: 15,
      displayColors: false,
      caretPadding: 10,
      callbacks: {
        label: function (tooltipItems, data) {
          let i;
          const label = [];
          const l = data.datasets.length;

          const total = data.datasets[0].data.reduce(
            (a, b) => Number(a) + Number(b),
            0
          );
          for (i = 0; i < l; i += 1) {
            const platform = data.labels[tooltipItems.index].split(':')[0];
            const value = data.datasets[0].data[tooltipItems.index];

            let percent = (value / total) * 100;
            percent = formatNumber(percent);

            label[i] = `${platform}: ${percent}%`;
          }
          return label;
        },
      },
    },
    legend: {
      display: true,
      labels: {
        fontSize: 16,
      },
    },
    cutoutPercentage: 60,
  };

  async function fetchPackages() {
    setLoading(true);
    Request.get('/admin/dashboard/packages', null, { normalizeJSON: false })
      .then((response) => {
        setLoading(false);
        setDoctorCount(response.doctor);
        setDoctorAllCount(response.doctor_all);
        setDrivingCount(response.driving);
        setEmergencyCount(response.emergency);
        setUsersCount(response.users);
        setPackagesByspecialty(response.packagesBySpecialty);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e);
      });
  }

  useEffect(() => {
    fetchPackages();
  }, []);

  return (
    <>
      <Paper
        Icon={ShoppingCartIcon}
        iconColor="blue"
        title={t('dashboard.tabs.packages')}
        loading={false}
      >
        <LinearProgress loading={loading} />

        <GridContainer>
          <GridItem xs={12} sm={6} md={4} lg={4} xl={4}>
            <CardMini
              Icon={LocalHospitalIcon}
              iconColor="green"
              text={t('constants.packages.doctor')}
              value={doctorCount}
              loading={loading}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={4} xl={4}>
            <CardMini
              Icon={LocalHospitalIcon}
              iconColor="green"
              text={t('constants.packages.doctor_all')}
              value={doctorAllCount}
              loading={loading}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={4} xl={4}>
            <CardMini
              Icon={DirectionsCarIcon}
              iconColor="blue"
              text={t('constants.packages.driving')}
              value={drivingCount}
              loading={loading}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={4} xl={4}>
            <CardMini
              Icon={AddAlertIcon}
              iconColor="red"
              text={t('constants.packages.emergency')}
              value={emergencyCount}
              loading={loading}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={4} xl={4}>
            <CardMini
              Icon={RoomIcon}
              iconColor="blue"
              text={t('constants.packages.users')}
              value={usersCount}
              loading={loading}
            />
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <GridContainer justify="center" alignItems="center">
          <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h6">
              {t('dashboard.attributes.count_packages_by_specialty')}
            </Typography>
            <Doughnut data={getPiePackagesBySpecialty} options={pieOptions} />
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />
      </Paper>
    </>
  );
}

export default ShowCorporation;
